// src/pages/Services.js
import React from 'react';
import { Link } from 'react-router-dom';
import s1 from '../assets/img/services/s1.jpg';
import s2 from '../assets/img/services/s2.jpg';
import s3 from '../assets/img/services/s3.jpg';
import s4 from '../assets/img/services/s4.jpg';
import s5 from '../assets/img/services/s5.jpg';
import s6 from '../assets/img/services/s6.jpg';
import checkIcon from '../assets/img/icons/check.png';
import bg4 from '../assets/img/bg-img/bg4.jpg';

export default function Services() {
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcumb-area clearfix auto-init">
        <div className="breadcumb-content">
          <div className="container h-100">
            <div className="row h-100 align-items-center">
              <div className="col-12">
                <nav aria-label="breadcrumb" className="breadcumb--con text-center">
                  <h2 className="w-text title wow fadeInUp" data-wow-delay="0.2s">Services</h2>
                  <ol className="breadcrumb justify-content-center wow fadeInUp" data-wow-delay="0.4s">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Services</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Our Services Area */}
      <section className="our_services_area section-padding-100-0 relative map-before" id="services">
        <div className="container">
          <div className="section-heading text-center">
            <span>Our Services</span>
            <h2 className="d-blue bold fadeInUp" data-wow-delay="0.3s">Translation Services</h2>
            <p className="fadeInUp" data-wow-delay="0.4s">
              We offer a comprehensive suite of language services tailored to your needs.
            </p>
          </div>
          <div className="row">
            {[
              { img: s1, title: 'Translation Workflow', text: 'Separate native-speaker translators and dedicated proofreaders on every job—no matter the size—for consistent, publication-ready results.' },
              { img: s2, title: 'Market Localisation', text: 'Tailor products, campaigns, and documentation to local customs and buying habits, maximizing the “comfort factor” that drives purchase decisions.' },
              { img: s5, title: 'DTP Services', text: 'Full-service formatting in QuarkXPress, InDesign, Adobe Creative Suite, and more, ensuring layouts are ready for both print and web.' },
              { img: s3, title: 'Voiceover & Subtitling', text: 'Professional voice talent and accurate captioning for diverse multimedia video content worldwide.' },
              { img: s4, title: 'Multimedia Services', text: 'Localization of images, audio, graphics, text, and highly engaging interactive digital media.' },
              { img: s6, title: 'CAD Services', text: 'Technical drawing translation for engineering, architecture, construction, and industrial projects.' }
            ].map((svc, i) => (
              <div className="col-12 col-md-6 col-lg-4" key={i}>
                <div className="service_single_content text-center wow fadeInUp" data-wow-delay={`${0.2 + 0.1 * i}s`}>
                  <div className="serv_icon">
                    <img src={svc.img} alt="" />
                  </div>
                  <div className="service-content">
                    <h6 className="w-text bold">{svc.title}</h6>
                    <p className="g-text">{svc.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Our Agency */}
      <section className="demo-video-sec section-padding-100 relative">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-4" />
            <div className="col-lg-8">
              <div className="who-we-contant">
                <div className="promo-section">
                  <h3 className="special-head">About Our Translation Agency!</h3>
                </div>
                <h4 className="d-blue bold fadeInUp" data-wow-delay="0.3s">
                  Expert Linguists Delivering Accurate Translations Worldwide
                </h4>
                <p className="fadeInUp" data-wow-delay="0.4s">
                  Ardent Translations bridges language barriers across industries, providing document translation,
                  website localization, voiceover &amp; subtitling, and DTP services with cultural nuance and precision.
                </p>
                <div className="list-wrap align-items-center">
                  <div className="row">
                    <div className="col-md-7 col-sm-7">
                      {['Document Translation','Website Localization','Voiceover & Subtitling','DTP & Desktop Publishing'].map((item,i)=>(
                        <div className="side-feature-list-item" key={i}>
                          <img src={checkIcon} className="check-mark-icon" alt="check" />
                          <div className="foot-c-info">{item}</div>
                        </div>
                      ))}
                    </div>
                    <div className="col-lg-5 col-sm-5 col-xs-12">
                      <div className="image-area mt-s fadeInUp" data-wow-delay="0.5s">
                        <div className="image-wrapper">
                          <img src={bg4} alt="translation services" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}